"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_colorful_1 = require("react-colorful");
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var BottomSheet_1 = __importDefault(require("stremio/components/BottomSheet"));
var ModalDialog_1 = __importDefault(require("stremio/components/ModalDialog"));
var useBinaryState_1 = __importDefault(require("stremio/common/useBinaryState"));
var useMediaQuery_1 = __importDefault(require("stremio/common/useMediaQuery"));
var screen_sizes_less_1 = __importDefault(require("stremio/common/screen-sizes.less"));
var ColorInput_less_1 = __importDefault(require("./ColorInput.less"));
var ColorInput = function (_a) {
    var className = _a.className, value = _a.value, onChange = _a.onChange, onClick = _a.onClick, props = __rest(_a, ["className", "value", "onChange", "onClick"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var isMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(screen_sizes_less_1.default.xsmall, ")"));
    var _b = (0, useBinaryState_1.default)(false), modalOpen = _b[0], openModal = _b[1], closeModal = _b[2];
    var _c = (0, react_1.useState)(value), tempValue = _c[0], setTempValue = _c[1];
    var labelButtonStyle = (0, react_1.useMemo)(function () { return ({
        backgroundColor: value
    }); }, [value]);
    var isTransparent = (0, react_1.useMemo)(function () {
        var hex = value.replace('#', '');
        return hex.length === 8 && hex.endsWith('00');
    }, [value]);
    var labelButtonOnClick = (0, react_1.useCallback)(function (event) {
        if (typeof onClick === 'function') {
            onClick(event);
        }
        setTempValue(value);
        openModal();
    }, [onClick, value, openModal]);
    var selectButtonOnClick = (0, react_1.useCallback)(function () {
        if (typeof onChange === 'function') {
            onChange(tempValue);
        }
        closeModal();
    }, [onChange, tempValue, closeModal]);
    var modalButtons = (0, react_1.useMemo)(function () { return [
        {
            label: t('SELECT'),
            props: {
                'data-autofocus': true,
                onClick: selectButtonOnClick
            }
        }
    ]; }, [selectButtonOnClick, t]);
    var picker = (react_1.default.createElement(react_colorful_1.HexAlphaColorPicker, { className: ColorInput_less_1.default['color-picker'], color: tempValue, onChange: setTempValue }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Button, __assign({ title: isTransparent ? t('BUTTON_COLOR_TRANSPARENT') : value }, props, { style: labelButtonStyle, className: (0, classnames_1.default)(className, ColorInput_less_1.default['color-input-container']), onClick: labelButtonOnClick }), isTransparent ?
            react_1.default.createElement("div", { className: ColorInput_less_1.default['transparent-label-container'] },
                react_1.default.createElement("div", { className: ColorInput_less_1.default['transparent-label'] }, t('BUTTON_COLOR_TRANSPARENT')))
            :
                null),
        isMobile ?
            react_1.default.createElement(BottomSheet_1.default, { className: ColorInput_less_1.default['color-sheet'], title: t('CHOOSE_COLOR'), show: modalOpen, onCloseRequest: closeModal, closeOnContentClick: false },
                picker,
                react_1.default.createElement(components_1.Button, { className: ColorInput_less_1.default['select-button'], onClick: selectButtonOnClick }, t('SELECT')))
            :
                modalOpen ?
                    react_1.default.createElement(ModalDialog_1.default, { title: t('CHOOSE_COLOR'), buttons: modalButtons, onCloseRequest: closeModal }, picker)
                    :
                        null));
};
exports.default = ColorInput;
